import React from 'react';
import { motion } from 'framer-motion';
import { Magnet } from 'lucide-react';
export function SystemIman() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-cream-50 relative overflow-hidden" data-id="element-160">
      {/* Decorative background element */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-161" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-163">
          <div className="inline-flex items-center justify-center p-4 bg-navy-900 rounded-2xl mb-6 shadow-lg" data-id="element-164">
            <Magnet className="w-10 h-10 text-gold-500" data-id="element-165" />
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy-900 mb-6" data-id="element-166">
            Presentamos el Sistema IMÁN
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-167">
            No es una app mágica ni inteligencia artificial compleja. Es un
            protocolo de comunicación humana basado en la psicología de la alta
            autoridad.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-168">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-8" data-id="element-169">
            <div className="bg-white p-8 rounded-2xl shadow-xl border border-cream-100" data-id="element-170">
              <ul className="space-y-6" data-id="element-171">
                {[{
                letter: 'I',
                text: 'nterés'
              }, {
                letter: 'M',
                text: 'icro-acuerdos'
              }, {
                letter: 'A',
                text: 'utoridad'
              }, {
                letter: 'N',
                text: 'egociación'
              }].map((item, i) => <li key={i} className="flex items-center text-2xl sm:text-3xl font-serif font-bold text-navy-800" data-id="element-172">
                    <span className="text-gold-500 mr-1" data-id="element-173">{item.letter}</span>
                    <span data-id="element-174">{item.text}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-175">
            <p data-id="element-176">
              Aprenderás a aplicar la{' '}
              <strong className="text-navy-900" data-id="element-177">
                Técnica de la Pregunta Espejo
              </strong>{' '}
              y el <strong className="text-navy-900" data-id="element-178">Protocolo C.Q.C.</strong>{' '}
              para que sea el cliente quien sienta la necesidad de convencerte a
              TI de que es el candidato ideal para tu servicio.
            </p>
            <div className="bg-navy-900 text-cream-50 p-6 rounded-xl border-l-4 border-gold-500 shadow-md" data-id="element-179">
              <p className="font-medium" data-id="element-180">
                Recuperarás el control de la conversación desde el primer
                mensaje.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}